import Vue from "vue";
import Router from "vue-router";
import GMap from "@/components/home/GMap";
import Signup from "@/components/auth/Signup";
import Login from "@/components/auth/Login";
import ViewProfile from "@/components/profile/ViewProfile";
import firebase from "firebase";

Vue.use(Router);
// history mode removes #/ from routes, may need to be toggled to enable development on localhost
const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "GMap",
      component: GMap,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/signup",
      name: "Signup",
      component: Signup,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/profile/:id",
      name: "ViewProfile",
      component: ViewProfile,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

// router guards
router.beforeEach((to, from, next) => {
  // check to see if route has auth guard
  if (to.matched.some((rec) => rec.meta.requiresAuth)) {
    // check auth state of user
    let user = firebase.auth().currentUser;
    if (user) {
      // User is signed in. Proceed to route
      next();
    } else {
      // No user is signed in. Redirect to login
      next({
        name: "Login",
      });
    }
  } else {
    // if route is not guarded by auth, proceed
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js